(function() { module.exports = this["jQuery"]; }());